import { Environment } from '../environment';

export const environment: Environment = {
    apiUrl: 'https://dev-api-marida.techcrowd.space',
    production: false,
};
